import { useNavigate } from 'react-router-dom'
import { usePerson } from '../../contexts/PersonContext'
import { useAuth } from '../../contexts/AuthContext'
import { superviseNote, viewingAsLabel } from '../../lib/personDisplay'
import { SectionLabel } from '../ui/SectionLabel'

/** Bottom-of-sidebar "Viewing as" card with the account sign-out affordance. */
export function ViewingAsCard() {
  const { activePerson, accountHolderId, isSolo, people, guardianFirst } = usePerson()
  const { logout } = useAuth()
  const navigate = useNavigate()

  if (!activePerson) return null

  const isHolder = activePerson.id === accountHolderId
  const managedCount = Math.max(0, people.length - 1)

  function signOut() {
    logout()
    navigate('/login')
  }

  return (
    <div className="mt-auto flex flex-col gap-2 rounded-[10px] bg-paper-deep px-3 py-[14px]">
      <SectionLabel>Viewing as</SectionLabel>
      <div className="text-[13px] font-medium text-ink">
        {viewingAsLabel(activePerson, isHolder, isSolo)}
      </div>
      <p className="text-[11.5px] leading-relaxed text-ink-muted">
        {superviseNote({ activePerson, isAccountHolder: isHolder, isSolo, managedCount, guardianFirst })}
      </p>
      <button
        type="button"
        onClick={signOut}
        className="text-left font-sans text-[11.5px] font-medium text-terra-deep hover:text-terra-hover"
      >
        Sign out
      </button>
    </div>
  )
}
